export default "__VITE_ASSET__C0NM$k4B__"